import { FetchStatus, FetchStatusInitialStatus, } from '../constants/fetch_status';
/**
 *
 * @param {Object} statusForPortalAction
 * @param {Object} portalAction member of PortalActions enum.
 * @param {Object} statusForPortalAction[portalAction] the fetch status object for specified portalAction.
 * @param {string} statusForPortalAction[portalAction].status the fetch status for specified portalAction.
 * @returns string
 */
export var getFetchStatusString = function (statusForPortalAction, portalAction) {
    var _a;
    return (((_a = statusForPortalAction === null || statusForPortalAction === void 0 ? void 0 : statusForPortalAction[portalAction]) === null || _a === void 0 ? void 0 : _a.status) ||
        FetchStatusInitialStatus.INITIAL_FETCH_STATUS);
};
/**
 *
 * @param {Object} statusForPortalAction
 * @param {Object} portalAction member of PortalActions enum.
 * @param {Object} statusForPortalAction[portalAction] the fetch status object for specified portalAction.
 * @param {string} statusForPortalAction[portalAction].status the fetch status for specified portalAction.
 * @returns boolean
 */
export var isFetchPending = function (statusForPortalAction, portalAction) {
    var fetchStatusString = getFetchStatusString(statusForPortalAction, portalAction);
    return (fetchStatusString === FetchStatusInitialStatus.INITIAL_FETCH_STATUS ||
        fetchStatusString === FetchStatus.PENDING);
};
/**
 *
 * @param {Object} statusForPortalAction
 * @param {Object} portalAction member of PortalActions enum.
 * @param {Object} statusForPortalAction[portalAction] the fetch status object for specified portalAction.
 * @param {string} statusForPortalAction[portalAction].status the fetch status for specified portalAction.
 * @returns boolean
 */
export var isFetchFulfilled = function (statusForPortalAction, portalAction) {
    var fetchStatusString = getFetchStatusString(statusForPortalAction, portalAction);
    return fetchStatusString === FetchStatus.FULFILLED;
};
/**
 *
 * @param {Object} statusForPortalAction
 * @param {Object} portalAction member of PortalActions enum.
 * @param {Object} statusForPortalAction[portalAction] the fetch status object for specified portalAction.
 * @param {string} statusForPortalAction[portalAction].status the fetch status for specified portalAction.
 * @returns boolean
 */
export var isFetchRejected = function (statusForPortalAction, portalAction) {
    var fetchStatusString = getFetchStatusString(statusForPortalAction, portalAction);
    return fetchStatusString === FetchStatus.REJECTED;
};
